<template>
  <div>
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">机侧题库</Breadcrumb-item>
        <Breadcrumb-item>试做试卷</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search mex-search">
      <Form :show-message="false" label-position="top">
        <Row :gutter="16">
          <i-col :span="12">
            <Form-item label="考试类型">
              <Select v-model="form.examType" placeholder="请选择考试类型">
                <Option value="PLACEMENT">入门测</Option>
                <Option value="SUMMATIVE">阶段测</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="6">
            <Form-item label="出生年">
              <Select v-model="form.birthYear" placeholder="年">
                <Option v-for="y in birthYears" :value="y" :key="'by'+y">{{y}} 年</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="6">
            <Form-item label="出生月">
              <Select v-model="form.birthMonth" placeholder="月">
                <Option v-for="m in 12" :value="m" :key="'bm'+m">{{m}} 月</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col v-if="form.examType === 'PLACEMENT'" :span="12">
            <Form-item label="宝贝目前的英语水平">
              <Select v-model="form.selfLevel" placeholder="与 App 探险证同一套五档">
                <Option value="ZERO">基本零基础</Option>
                <Option value="BEGINNER">刚入门</Option>
                <Option value="BASIC">有基础</Option>
                <Option value="GOOD">挺不错</Option>
                <Option value="FLUENT">很熟练</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col v-if="form.examType === 'SUMMATIVE'" :span="12">
            <Form-item label="当前课程级别">
              <Select v-model="form.courseLevel" placeholder="与学生当前级别一致">
                <Option v-for="lv in courseLevels" :value="lv" :key="lv">{{lv}}</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="12">
            <Form-item label="抽题方式">
              <Select v-model="form.shuffle" placeholder="请选择抽题方式">
                <Option :value="0">按权重从高到低（接近引擎）</Option>
                <Option :value="1">随机（方便多抽几套）</Option>
              </Select>
            </Form-item>
          </i-col>
        </Row>
        <div class="mex-search-actions">
          <Button type="primary" :loading="drawing" @click="drawBlueprint">开始抽题</Button>
          <Button :loading="drawing" @click="drawWalk('TYPES')">试做所有题型</Button>
          <Button :loading="drawing" @click="drawWalk('ALL')">做所有题目</Button>
          <Button v-if="paper" @click="resetPaper">清空本套</Button>
          <Button v-if="paper && paper.sessionId" @click="goSession">查看场次记录</Button>
          <Button v-if="paper && paper.sessionId && (report || paper.sessionStatus === 'READY')" type="success" @click="loadReport">查看模拟报告</Button>
        </div>
        <p class="mex-dim-hint">「开始抽题」按蓝图抽一套。「试做所有题型」每种呈现形态一道。「做所有题目」通刷该考试类型已上线全库，题量会很多。</p>
      </Form>
    </div>
    <Alert v-if="paper && paper.warnings && paper.warnings.length" type="warning" show-icon style="margin-top:10px">
      <p v-for="(w, i) in paper.warnings" :key="'w'+i">{{w}}</p>
    </Alert>
    <div v-if="paper" class="mex-trial-explain">
      <h3>抽题规则</h3>
      <ol>
        <li v-for="(r, i) in (paper.rules || [])" :key="'rule'+i">{{r}}</li>
      </ol>
      <h3>使用的蓝图</h3>
      <Table :columns="bpColumns" :data="paper.blueprints || []" size="small"></Table>
      <template v-if="!isWalkPaper">
        <h3>槽位对照</h3>
        <p class="mex-dim-hint">橙色行＝应抽不足；浅黄行＝已放宽 exam_scene/级别。业务键可回题库核对。</p>
        <Table :columns="traceColumns" :data="paper.traces || []" size="small" :row-class-name="traceRowClass"></Table>
      </template>
    </div>
    <div v-if="paper && prepVisible" class="mex-trial-phone-wrap">
      <p class="mex-dim-hint">以下按《机考全流程设计规范 v2.5》模拟 App 测试前准备，通过后才进入答题。</p>
      <div class="mex-trial-phone">
        <div class="mex-trial-phone-bar">迷雾森林 · 松鼠松果大冒险</div>
        <div v-if="prepStep === 'consent'" class="mex-trial-phone-body">
          <h3>欢迎来到迷雾森林</h3>
          <p>请让孩子独立答题，不要提示或帮忙。</p>
          <p>请保持环境安静，测试时不要打扰。</p>
          <p>请仅协助操作设备，不干预答题过程。</p>
          <p>请保证结果真实，匹配适合的学习内容。</p>
          <Checkbox v-model="prep.agreed">我已阅读并同意以上公约，以及《用户隐私政策》《儿童个人信息保护规则》</Checkbox>
          <Button type="primary" long :disabled="!prep.agreed" :loading="preparing" @click="submitPrep('CONSENT')">同意并开始</Button>
        </div>
        <div v-if="prepStep === 'profile'" class="mex-trial-phone-body">
          <h3>领取你的森林探险证</h3>
          <p>填写年龄可以帮助我们更准确地匹配题目难度</p>
          <p>出生年月</p>
          <Row :gutter="8">
            <i-col :span="12">
              <Select v-model="prep.birthYear" disabled placeholder="年">
                <Option v-for="y in birthYears" :value="y" :key="y">{{y}} 年</Option>
              </Select>
            </i-col>
            <i-col :span="12">
              <Select v-model="prep.birthMonth" disabled placeholder="月">
                <Option v-for="m in 12" :value="m" :key="m">{{m}} 月</Option>
              </Select>
            </i-col>
          </Row>
          <template v-if="paper.examType === 'PLACEMENT'">
            <p style="margin-top:12px">宝贝目前的英语水平</p>
            <Select v-model="prep.selfLevel" disabled placeholder="已按此档抽卷">
              <Option value="ZERO">基本零基础</Option>
              <Option value="BEGINNER">刚入门</Option>
              <Option value="BASIC">有基础</Option>
              <Option value="GOOD">挺不错</Option>
              <Option value="FLUENT">很熟练</Option>
            </Select>
            <p class="mex-dim-hint">已按此档抽卷，准备流里不能再改档位。</p>
          </template>
          <p v-else class="mex-dim-hint" style="margin-top:12px">阶段测按当前课程级别 {{paper.courseLevel}} 抽卷，不填英语自评。</p>
          <Checkbox v-model="prep.profileAgreed" style="margin-top:12px">同意使用以上信息提供测评服务，仅用于匹配题目难度，不会对外公开</Checkbox>
          <Button type="primary" long :disabled="!prep.profileAgreed" :loading="preparing" @click="submitPrep('PROFILE')">下一步</Button>
        </div>
        <div v-if="prepStep === 'audio'" class="mex-trial-phone-body">
          <h3>先试试你的探险耳机</h3>
          <p>点击播放，听听小松鼠说话。如果能清楚听到声音，就可以继续。</p>
          <Button long @click="playAudio">▶ 播放测试音频</Button>
          <p class="mex-dim-hint">如果声音太小或太大，可以调整设备音量</p>
          <Button type="primary" long :disabled="!prep.audioPlayed" :loading="preparing" @click="submitPrep('AUDIO')">听得到，下一步</Button>
        </div>
        <div v-if="prepStep === 'mic'" class="mex-trial-phone-body">
          <h3>再试试你的魔法麦克风</h3>
          <p>点击后 3 秒倒计时，再说一句 Hello, squirrel! 会自动录 3 秒并回听。</p>
          <p v-if="prep.micHint" class="mex-dim-hint">{{prep.micHint}}</p>
          <Button long :disabled="prep.micBusy" @click="startMic">开始录音调试</Button>
          <Button type="primary" long :disabled="!prep.micOk" :loading="preparing" @click="submitPrep('MIC')">没问题，开始探险</Button>
        </div>
        <div v-if="prepStep === 'loading'" class="mex-trial-phone-body">
          <h3>正在准备森林探险...</h3>
          <Progress :percent="prep.loadPct" :stroke-width="12"></Progress>
        </div>
      </div>
    </div>
    <div v-if="paper && inExam" class="mex-trial-wrap">
      <div class="mex-trial-nav">
        <p>蓝图 {{paper.blueprintVersion}} · {{segmentLabel(paper.segment)}} · 限时 {{paper.durationSec || '—'}} 秒 · 场次 {{paper.sessionId}} · 共 {{items.length}} 题 · 已做 {{doneCount}} · 得分 {{totalGot}} / {{totalFull}}</p>
        <p class="mex-dim-hint">提交本题会写入场次记录（可回放）；不计入题目曝光统计。「下一题」若还没交会先提交再跳。</p>
        <div class="mex-trial-dots">
          <span v-for="it in items" :key="it.seq" class="mex-trial-dot" :class="dotClass(it)" @click="go(it.seq - 1)">{{it.seq}}</span>
        </div>
        <div v-if="showGuide" class="mex-trial-guide" @click="showGuide = false">认真做题就能收集金色松果哦！不会做的题可以点「跳过」，加油！</div>
      </div>
      <div v-if="current" class="mex-trial-card">
        <p class="mex-trial-meta">
          第 {{current.seq}} 题 · {{skillLabel(current.skill)}} · {{current.questionType}} · {{current.businessCode}} · {{catReasonLabel(current.catReason)}} · 满分 {{current.fullScore || 1}}
        </p>
        <Alert v-if="current.issues && current.issues.length" type="error" show-icon>
          题目可能有错：{{current.issues.join('；')}}
        </Alert>
        <p v-if="current.instructionCn"><b>中文指令</b> {{current.instructionCn}}</p>
        <p v-if="current.instructionEn"><b>英文指令</b> {{current.instructionEn}}</p>
        <p v-if="current.script"><b>脚本</b> {{current.script}}</p>
        <p v-if="current.passageText"><b>篇章</b> {{current.passageText}}</p>
        <p v-if="mediaSrc(current.passageImage)"><img :src="mediaSrc(current.passageImage)" class="mex-trial-img"></p>
        <p class="mex-trial-stem">{{current.stem}}</p>
        <p v-if="mediaSrc(current.stemImage)"><img :src="mediaSrc(current.stemImage)" class="mex-trial-img"></p>
        <p v-if="mediaSrc(current.stemAudio)">
          <audio :src="mediaSrc(current.stemAudio)" controls></audio>
        </p>
        <div v-if="isChoiceBlanks && blankView.length">
          <div v-for="b in blankView" :key="'cz-' + b.no" class="mex-trial-opts" style="margin-bottom:12px">
            <p>第 {{b.no}} 问 {{b.prompt}}</p>
            <Radio-group v-model="b.value">
              <Radio v-for="opt in (b.options || [])" :label="opt.code" :key="b.no + '-' + opt.code" style="display:block;margin:8px 0">
                {{opt.code}}. {{opt.text}}
              </Radio>
            </Radio-group>
          </div>
        </div>
        <div v-if="isWordForm && optView.options.length" class="mex-trial-opts">
          <p><b>词库</b> {{optView.options.map(o => o.text).filter(t => t).join(' / ')}}</p>
        </div>
        <div v-if="optView.mode === 'CHOICE' && !isChoiceBlanks && !isWordForm" class="mex-trial-opts">
          <Radio-group v-model="draft.choice">
            <Radio v-for="opt in optView.options" :label="opt.code" :key="opt.code" style="display:block;margin:8px 0">
              {{opt.code}}. {{opt.text}}
              <img v-if="mediaSrc(opt.image)" :src="mediaSrc(opt.image)" class="mex-trial-opt-img">
            </Radio>
          </Radio-group>
        </div>
        <div v-if="optView.mode === 'DRAG'">
          <p>可拖词块：{{optView.tokens.join(' / ')}}</p>
          <Input v-model="draft.text" placeholder="按正确顺序拼好后填在这里，如 ball 或 What do you need?"></Input>
        </div>
        <div v-if="blankView.length && !isChoiceBlanks">
          <Row :gutter="12">
            <i-col :span="(isFillBlanks || isWordForm) ? 24 : 8" v-for="b in blankView" :key="b.no">
              <p>第 {{b.no}} 空 {{b.prompt}}</p>
              <Input v-model="b.value" :placeholder="isFillBlanks ? '这一空的短语' : (isWordForm ? '这一空的词形，如 is coloring' : (b.prompt || '这一空的答案'))"></Input>
            </i-col>
          </Row>
        </div>
        <div v-if="optView.mode !== 'CHOICE' && !blankView.length && optView.mode !== 'DRAG' && !isChoiceBlanks">
          <Input v-model="draft.text" type="textarea" :rows="4" :placeholder="answerPh"></Input>
        </div>
        <Checkbox v-if="isSubjectiveWrite" v-model="draft.ocrConfirm">已确认识别内容（写作主观分需要）</Checkbox>
        <div style="margin-top:12px">
          <Button type="primary" :loading="scoring" @click="submitCurrent(0)">提交本题</Button>
          <Button @click="submitCurrent(1)">跳过（0分）</Button>
          <Button @click="prev" :disabled="index === 0">上一题</Button>
          <Button @click="next" :disabled="index >= items.length - 1">下一题</Button>
        </div>
        <div v-if="current.result" class="mex-trial-result">
          <p><b>判分</b> {{current.result.score}} / {{current.result.fullScore}} · {{current.result.mastered === 1 ? '掌握' : '未掌握'}} · {{scorerLabel(current.result.scorer)}}</p>
          <p><b>你的作答</b> {{current.result.payload || '（空）'}}</p>
          <p><b>标准答案</b> {{current.result.expected || '（空）'}}</p>
          <p v-if="current.result.note" class="mex-dim-hint">{{current.result.note}}</p>
        </div>
      </div>
    </div>
    <div v-if="report" class="mex-trial-report">
      <h3>模拟家长报告</h3>
      <p class="mex-dim-hint" v-for="(n, i) in (report.notes || [])" :key="'n'+i">{{n}}</p>
      <div class="mex-trial-report-hero">
        <p><b>{{report.title || '—'}}</b> · {{report.medalLabel || '—'}} · 百分制 {{report.totalScore}}</p>
        <p>
          {{report.examType === 'SUMMATIVE' ? '阶段测' : '入门测'}}
          · {{placementPublishLine(report)}}
          · 升班 {{report.promotionLabel || '—'}}
          · 年龄档 {{ageBandLabel(report.ageBand)}}
        </p>
        <p v-if="report.examType === 'PLACEMENT'" class="mex-dim-hint">
          触达 {{report.visitedMaxLevel || '—'}}
          · 候选 {{report.candidateLevel || '—'}}
          · 已验证 {{report.confirmedLevel || '—'}}
          · 规则 {{report.ruleVersion || '—'}}
        </p>
      </div>
      <h4>听说读写</h4>
      <Table :columns="skillColumns" :data="report.skills || []" size="small"></Table>
      <h4>学习建议</h4>
      <p class="mex-trial-advice">{{report.advice || '暂无'}}</p>
    </div>
  </div>
</template>

<script>
import { assetUrl } from './mex-asset'

export default {
  name: 'MexTrialPaper',
  data () {
    return {
      drawing: false,
      scoring: false,
      form: {
        examType: 'PLACEMENT',
        selfLevel: 'BASIC',
        courseLevel: 'L2',
        shuffle: 0,
        birthYear: 2018,
        birthMonth: 6
      },
      courseLevels: ['L1', 'L2', 'L3', 'L4', 'L5', 'L6', 'L7', 'L8'],
      birthYears: [2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023],
      paper: null,
      items: [],
      index: 0,
      progressRev: 0,
      report: null,
      preparing: false,
      prepStep: 'consent',
      showGuide: false,
      entering: false,
      prep: {
        agreed: false,
        birthYear: 2018,
        birthMonth: 6,
        selfLevel: 'BASIC',
        profileAgreed: false,
        audioPlayed: false,
        micOk: false,
        micBusy: false,
        micHint: '',
        loadPct: 0
      },
      draft: { choice: '', text: '', ocrConfirm: false },
      shownAt: 0
    }
  },
  watch: {
    index () {
      this.markShown()
    },
    inExam (val) {
      if (val) this.markShown()
    }
  },
  computed: {
    current () {
      return this.items[this.index] || null
    },
    inExam () {
      if (!this.paper || this.entering) return false
      let s = this.paper.sessionStatus
      return s === 'IN_PROGRESS' || s === 'READY'
    },
    prepVisible () {
      return this.paper && !this.inExam && !this.report
    },
    optView () {
      return this.parseOptions(this.current)
    },
    blankView () {
      if (!this.current) return []
      return this.current._blanks || []
    },
    isCloze () {
      if (!this.current) return false
      return (this.current.questionType || '') === 'Cloze'
    },
    isChoiceBlanks () {
      if (this.isCloze) return true
      let blanks = this.blankView
      if (!blanks || !blanks.length) return false
      return blanks.some(b => b.options && b.options.length)
    },
    isFillBlanks () {
      if (!this.current) return false
      return (this.current.questionType || '') === 'Fill in the Blanks'
    },
    isWordForm () {
      if (!this.current) return false
      let t = this.current.questionType || ''
      return t === 'Fill Passage - Word Form' || t === 'Fill in Blank - Word Form'
    },
    isSubjectiveWrite () {
      if (!this.current) return false
      let t = this.current.questionType || ''
      return t.indexOf('Picture Writing') >= 0 || t.indexOf('Practical Writing') >= 0 || t.indexOf('Guided Writing') >= 0
    },
    isWalkPaper () {
      if (!this.paper) return false
      return this.paper.walkMode === 'ALL' || this.paper.walkMode === 'TYPES'
    },
    answerPh () {
      if (!this.current) return '请输入作答'
      if (this.current.bank === 'SPEAK') return '试做填跟读/标准文本，如 apple'
      if (this.isSubjectiveWrite) return '写入作答文本，并勾选已确认'
      if (this.isFillBlanks) return '每空填短语，多空用 | 连起来'
      if (this.isWordForm) return '每空填词形，多空用 ; 连起来，如 is coloring; wrote; do'
      return '选择题填代号；判断填 T/F；拼写填单词'
    },
    doneCount () {
      this.progressRev
      let n = 0
      this.items.forEach(it => {
        if (it.result) n++
      })
      return n
    },
    totalGot () {
      this.progressRev
      let n = 0
      this.items.forEach(it => {
        if (it.result) n += Number(it.result.score) || 0
      })
      return Math.round(n * 100) / 100
    },
    totalFull () {
      this.progressRev
      let n = 0
      this.items.forEach(it => {
        n += Number(it.fullScore) || 1
      })
      return Math.round(n * 100) / 100
    },
    bpColumns () {
      return [
        { title: 'ID', key: 'id', width: 70 },
        { title: '考试', key: 'examType', width: 90, render: (h, p) => h('span', this.examTypeLabel(p.row.examType)) },
        { title: '档位/级别段', key: 'segment', width: 110, render: (h, p) => h('span', this.segmentLabel(p.row.segment)) },
        { title: '版本', key: 'versionNo', width: 90 },
        { title: '状态', key: 'status', width: 80, render: (h, p) => h('span', this.statusLabel(p.row.status)) },
        { title: '限时(秒)', key: 'durationSec', width: 90 },
        { title: '题量上限', key: 'itemLimit', width: 90 },
        { title: '模块权重', key: 'moduleWeightsJson', render: (h, p) => h('span', p.row.moduleWeightsJson || '—') }
      ]
    },
    traceColumns () {
      return [
        { title: '来源', key: 'source', width: 80, render: (h, p) => h('span', p.row.source === 'ANCHOR' ? '锚题' : '槽位') },
        { title: '蓝图ID', key: 'blueprintId', width: 80 },
        { title: '蓝图档位', key: 'blueprintSegment', width: 90, render: (h, p) => h('span', this.segmentLabel(p.row.blueprintSegment)) },
        { title: '版本', key: 'blueprintVersion', width: 80 },
        { title: '题库', key: 'bank', width: 90, render: (h, p) => h('span', this.bankLabel(p.row.bank)) },
        { title: '技能', key: 'skill', width: 90, render: (h, p) => h('span', this.skillLabel(p.row.skill)) },
        { title: '题型', key: 'questionType', minWidth: 160 },
        { title: '应抽', key: 'need', width: 70 },
        { title: '实抽', key: 'got', width: 70 },
        { title: '分值', key: 'scoreEach', width: 70 },
        { title: '放宽', key: 'loosened', width: 70, render: (h, p) => h('span', p.row.loosened === 1 ? '是' : '否') },
        { title: '业务键', key: 'businessCodes', minWidth: 160, render: (h, p) => h('span', (p.row.businessCodes || []).join('、') || '—') },
        { title: '说明', key: 'note', minWidth: 220 }
      ]
    },
    skillColumns () {
      return [
        { title: '技能', key: 'skillLabel', width: 100 },
        { title: '百分制', key: 'score', width: 100 },
        { title: '强弱项', key: 'tag' }
      ]
    }
  },
  methods: {
    mediaSrc (path) {
      if (!this.current) return ''
      return assetUrl(path, this.current.skill)
    },
    skillLabel (code) {
      if (code === 'Listening') return '听力'
      if (code === 'Speaking') return '口语'
      if (code === 'Reading') return '阅读'
      if (code === 'Writing') return '写作'
      if (code === 'Listening/Reading') return '听/读'
      return code || ''
    },
    catReasonLabel (code) {
      if (code === 'ANCHOR') return '锚题'
      if (code === 'WALK_ALL') return '通刷'
      if (code === 'WALK_TYPES') return '题型覆盖'
      return '槽位'
    },
    examTypeLabel (code) {
      if (code === 'PLACEMENT') return '入门测'
      if (code === 'SUMMATIVE') return '阶段测'
      return code || ''
    },
    statusLabel (code) {
      if (code === 'ONLINE') return '已上线'
      if (code === 'OFFLINE') return '已下线'
      if (code === 'PENDING_REVIEW') return '待审核'
      if (code === 'DISCARDED') return '已废弃'
      return code || '—'
    },
    bankLabel (code) {
      if (code === 'COMP') return '综合库'
      if (code === 'SPEAK') return '口语库'
      return code || '—'
    },
    scorerLabel (code) {
      if (code === 'OBJECTIVE') return '客观题自动判分'
      if (code === 'WRITE_SUBJECTIVE') return '写作主观（字数规则）'
      if (code === 'SKIP') return '跳过记 0 分'
      return code || '—'
    },
    segmentLabel (code) {
      if (code === 'LOW') return '低档'
      if (code === 'MID') return '中档'
      if (code === 'HIGH') return '高档'
      if (code === 'LISTENING') return '听力'
      if (code === 'SPEAKING') return '口语'
      if (code === 'READING') return '阅读'
      if (code === 'WRITING') return '写作'
      if (code === 'L1-L2' || code === 'L3-L4' || code === 'L5-L6' || code === 'L7-L8') return code
      return code || '—'
    },
    placementPublishLabel (status) {
      let m = {
        VERIFIED: '已验证（正式定级）',
        PROVISIONAL: '暂定（非正式）',
        REVIEW: '待复核（无正式定级）',
        BELOW_L1: '未达 L1（无正式定级）'
      }
      return m[status] || (status || '—')
    },
    placementPublishLine (report) {
      if (!report || report.examType === 'SUMMATIVE') {
        return '定级 ' + ((report && report.placementLevel) || '—')
      }
      let st = report.publishStatus
      if (st === 'VERIFIED') {
        return this.placementPublishLabel(st) + ' ' + (report.confirmedLevel || report.placementLevel || '—')
      }
      if (st === 'PROVISIONAL') {
        return this.placementPublishLabel(st) + ' ' + (report.candidateLevel || report.placementLevel || '—')
      }
      if (st === 'REVIEW' || st === 'BELOW_L1') {
        return this.placementPublishLabel(st)
      }
      return '定级 ' + (report.placementLevel || '—')
    },
    ageBandLabel (code) {
      if (code === 'LOW') return '低龄'
      if (code === 'HIGH') return '高龄'
      if (code === 'MID') return '中龄'
      return code || '—'
    },
    traceRowClass (row) {
      if ((row.got || 0) < (row.need || 0)) return 'mex-trial-trace-short'
      if (row.loosened === 1) return 'mex-trial-trace-loose'
      return ''
    },
    parseOptions (item) {
      if (!item) return { mode: 'NONE', options: [], tokens: [] }
      let qtype = item.questionType || ''
      if (qtype === 'Cloze' || qtype === 'Gap Fill') {
        return { mode: 'NONE', options: [], tokens: item._wordBank || [] }
      }
      if (qtype === 'Picture Writing - Four Panel Story') {
        return { mode: 'NONE', options: [], tokens: [] }
      }
      let wordForm = qtype === 'Fill Passage - Word Form' || qtype === 'Fill in Blank - Word Form'
      if (!item.optionsJson) return { mode: 'NONE', options: [], tokens: [] }
      try {
        let data = typeof item.optionsJson === 'string' ? JSON.parse(item.optionsJson) : item.optionsJson
        if (Array.isArray(data) && data.length) {
          if (wordForm) {
            return { mode: 'BANK', options: data, tokens: [] }
          }
          let dragTokens = this.tokensFromMisimportedChoice(qtype, data)
          if (dragTokens) {
            return { mode: 'DRAG', options: [], tokens: dragTokens }
          }
          return { mode: 'CHOICE', options: data, tokens: [] }
        }
        if (data && (data.mode === 'DRAG' || data.tokens)) {
          return { mode: 'DRAG', options: [], tokens: data.tokens || [] }
        }
      } catch (e) {}
      return { mode: 'NONE', options: [], tokens: [] }
    },
    tokensFromMisimportedChoice (qtype, data) {
      let drag = (qtype || '').indexOf('Drag Letters') === 0 || qtype === 'Sequence - Sentence Ordering'
      if (!drag || !data || data.length !== 1) return null
      let text = (typeof data[0] === 'string' ? data[0] : (data[0].text || '')).replace(/｜/g, '|')
      if (text.indexOf('|') < 0) return null
      let tokens = text.split('|').map(s => s.trim()).filter(s => s)
      return tokens.length ? tokens : null
    },
    shuffleWords (arr) {
      let a = (arr || []).slice()
      for (let i = a.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1))
        let t = a[i]
        a[i] = a[j]
        a[j] = t
      }
      return a
    },
    attachBlanks (item) {
      let list = []
      if (item.blanksJson) {
        try {
          let data = typeof item.blanksJson === 'string' ? JSON.parse(item.blanksJson) : item.blanksJson
          if (data && data.length) {
            list = data.map((b, i) => {
              let options = (b.options || []).map(opt => {
                if (typeof opt === 'string') return { code: '', text: opt }
                return { code: opt.code || '', text: opt.text || '' }
              })
              return { no: b.no || i + 1, prompt: b.prompt || '', value: '', options: options }
            })
          }
        } catch (e) {}
      }
      this.$set(item, '_blanks', list)
    },
    drawBlueprint () {
      this.doDraw('')
    },
    drawWalk (mode) {
      this.doDraw(mode)
    },
    draw () {
      this.doDraw('')
    },
    doDraw (walkMode) {
      if (this.form.examType === 'PLACEMENT' && !this.form.selfLevel) {
        this.$Message.error('请选择宝贝目前的英语水平')
        return
      }
      if (this.form.examType === 'SUMMATIVE' && !this.form.courseLevel) {
        this.$Message.error('请选择当前课程级别')
        return
      }
      this.drawing = true
      this.$http.post('/mex/trial/draw', this.drawPayload(walkMode)).then(res => {
        this.drawing = false
        if (res.status === 'ok' && res.data) {
          this.paper = res.data
          this.items = (res.data.items || []).map(it => {
            it.result = null
            return it
          })
          this.items.forEach(it => this.attachBlanks(it))
          this.index = 0
          this.progressRev = 0
          this.report = null
          this.entering = false
          this.showGuide = false
          this.prepStep = 'consent'
          this.prep = {
            agreed: false,
            birthYear: this.form.birthYear,
            birthMonth: this.form.birthMonth,
            selfLevel: this.form.selfLevel || 'BASIC',
            profileAgreed: false,
            audioPlayed: false,
            micOk: false,
            micBusy: false,
            micHint: '',
            loadPct: 0
          }
          this.resetDraft()
        } else {
          this.$Message.error(res.msg || '抽题失败')
        }
      }).catch(() => {
        this.drawing = false
        this.$Message.error('抽题失败')
      })
    },
    drawPayload (walkMode) {
      let m = this.form.birthMonth < 10 ? '0' + this.form.birthMonth : '' + this.form.birthMonth
      let payload = {
        examType: this.form.examType,
        shuffle: this.form.shuffle,
        birthYm: this.form.birthYear + '-' + m
      }
      if (this.form.examType === 'PLACEMENT') {
        payload.selfLevel = this.form.selfLevel
      } else {
        payload.courseLevel = this.form.courseLevel
      }
      if (walkMode) {
        payload.walkMode = walkMode
      }
      return payload
    },
    resetPaper () {
      this.paper = null
      this.items = []
      this.index = 0
      this.progressRev = 0
      this.report = null
      this.entering = false
      this.showGuide = false
      this.prepStep = 'consent'
    },
    goSession () {
      this.$router.push({ path: '/mex/sessions' })
    },
    birthYm () {
      let m = this.prep.birthMonth < 10 ? '0' + this.prep.birthMonth : '' + this.prep.birthMonth
      return this.prep.birthYear + '-' + m
    },
    playAudio () {
      this.prep.audioPlayed = true
      let text = '嗨，我是小松鼠！你能听到我说话吗？我们一起去森林里收集金色松果吧！'
      if (window.speechSynthesis) {
        window.speechSynthesis.cancel()
        let u = new SpeechSynthesisUtterance(text)
        u.lang = 'zh-CN'
        window.speechSynthesis.speak(u)
      } else {
        this.$Message.info(text)
      }
    },
    startMic () {
      let self = this
      if (self.prep.micBusy) return
      self.prep.micBusy = true
      self.prep.micOk = false
      let n = 3
      self.prep.micHint = '倒计时 ' + n + ' 秒'
      let timer = setInterval(() => {
        n--
        if (n > 0) {
          self.prep.micHint = '倒计时 ' + n + ' 秒'
          return
        }
        clearInterval(timer)
        self.prep.micHint = '正在录音，请说 Hello, squirrel!'
        self.captureMic(ok => {
          self.prep.micBusy = false
          self.prep.micOk = !!ok
          self.prep.micHint = ok ? '录音成功，可以回听并开始探险' : '没听到有效人声，请再试一次'
        })
      }, 1000)
    },
    captureMic (done) {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        setTimeout(() => done(true), 3000)
        return
      }
      navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
        let rec = null
        try {
          rec = new MediaRecorder(stream)
        } catch (e) {
          stream.getTracks().forEach(t => t.stop())
          setTimeout(() => done(true), 3000)
          return
        }
        rec.start()
        setTimeout(() => {
          rec.stop()
        }, 3000)
        rec.onstop = () => {
          stream.getTracks().forEach(t => t.stop())
          done(true)
        }
      }).catch(() => {
        this.$Message.warning('浏览器未授权麦克风，已按调试通过处理')
        setTimeout(() => done(true), 800)
      })
    },
    submitPrep (step) {
      if (!this.paper || !this.paper.sessionId) return
      let payload = {
        sessionId: this.paper.sessionId,
        step: step,
        policyVersion: 'forest-v2.5',
        birthYm: this.birthYm(),
        selfLevel: this.prep.selfLevel,
        canHear: this.prep.audioPlayed ? 1 : 0,
        vadOk: this.prep.micOk ? 1 : 0
      }
      this.preparing = true
      this.$http.post('/mex/trial/prepare', payload).then(res => {
        this.preparing = false
        if (res.status !== 'ok') {
          this.$Message.error(res.msg || '准备步骤失败')
          return
        }
        this.paper.sessionStatus = res.data
        if (step === 'CONSENT') this.prepStep = 'profile'
        if (step === 'PROFILE') this.prepStep = 'audio'
        if (step === 'AUDIO') this.prepStep = 'mic'
        if (step === 'MIC') this.enterExam()
      }).catch(() => {
        this.preparing = false
        this.$Message.error('准备步骤失败')
      })
    },
    enterExam () {
      this.prepStep = 'loading'
      this.entering = true
      this.prep.loadPct = 0
      let n = 0
      let timer = setInterval(() => {
        n += 8
        if (n > 100) n = 100
        this.prep.loadPct = n
        if (n >= 100) {
          clearInterval(timer)
          this.entering = false
          this.showGuide = true
          setTimeout(() => { this.showGuide = false }, 3000)
        }
      }, 200)
    },
    loadReport () {
      if (!this.paper || !this.paper.sessionId) return
      this.$http.post('/mex/trial/report', { sessionId: this.paper.sessionId }).then(res => {
        if (res.status === 'ok' && res.data) {
          this.report = res.data
        } else {
          this.$Message.error(res.msg || '报告尚未生成')
        }
      }).catch(() => {
        this.$Message.error('加载报告失败')
      })
    },
    resetDraft () {
      this.draft = { choice: '', text: '', ocrConfirm: false }
      if (this.current && this.current._blanks) {
        this.current._blanks.forEach(b => { b.value = '' })
      }
    },
    payloadOf () {
      if (this.isWordForm && this.blankView.length) {
        return this.blankView.map(b => (b.value || '').trim()).join(';')
      }
      if (this.optView.mode === 'CHOICE') return this.draft.choice
      if (this.blankView.length) {
        return this.blankView.map(b => (b.value || '').trim()).join('|')
      }
      return this.draft.text
    },
    hasPayload () {
      if (this.blankView.length) {
        return this.blankView.some(b => (b.value || '').trim() !== '')
      }
      let v = this.payloadOf()
      return v !== null && v !== undefined && String(v).trim() !== ''
    },
    applyScore (data) {
      let idx = this.index
      let item = this.items[idx]
      if (!item) return
      this.$set(item, 'result', data)
      this.$set(this.items, idx, item)
      this.progressRev += 1
    },
    submitCurrent (skipped, after) {
      if (!this.current) return
      if (!skipped && !this.hasPayload()) {
        this.$Message.warning('请先作答，或点跳过')
        return
      }
      this.scoring = true
      this.$http.post('/mex/trial/score', {
        bank: this.current.bank,
        versionId: this.current.versionId,
        sessionId: this.paper.sessionId,
        seq: this.current.seq,
        payload: this.payloadOf(),
        skipped: skipped,
        ocrConfirm: this.draft.ocrConfirm ? 1 : 0,
        elapsedMs: this.elapsedMs()
      }).then(res => {
        this.scoring = false
        if (res.status === 'ok') {
          this.applyScore(res.data)
          if (res.data && res.data.sessionStatus) {
            this.paper.sessionStatus = res.data.sessionStatus
          }
          if (res.data && res.data.report) {
            this.report = res.data.report
            this.$Message.success('本套已全部提交，下方为模拟家长报告')
          }
          if (typeof after === 'function') after()
        } else {
          this.$Message.error(res.msg || '判分失败')
        }
      }).catch(() => {
        this.scoring = false
        this.$Message.error('判分失败')
      })
    },
    go (i) {
      this.index = i
      this.resetDraft()
    },
    markShown () {
      this.shownAt = Date.now()
    },
    elapsedMs () {
      if (!this.shownAt) return 0
      let n = Date.now() - this.shownAt
      return n < 0 ? 0 : n
    },
    prev () {
      if (this.index > 0) this.go(this.index - 1)
    },
    next () {
      if (this.index >= this.items.length - 1) return
      if (this.current && !this.current.result) {
        if (!this.hasPayload()) {
          this.$Message.warning('请先提交本题或点跳过，进度才会更新')
          return
        }
        this.submitCurrent(0, () => {
          if (this.index < this.items.length - 1) this.go(this.index + 1)
        })
        return
      }
      this.go(this.index + 1)
    },
    dotClass (it) {
      if (it.issues && it.issues.length && !it.result) return 'warn'
      if (!it.result) return ''
      if (it.result.mastered === 1) return 'ok'
      return 'bad'
    }
  }
}
</script>

<style lang="less">
@import './mex-search.less';

.mex-dim-hint {
  margin: 8px 0 0;
  color: #808695;
}

.mex-trial-explain {
  background: #fff;
  padding: 12px 16px;
  margin-top: 12px;
}

.mex-trial-explain h3 {
  margin: 12px 0 8px;
  font-size: 14px;
}

.mex-trial-explain ol {
  margin: 0 0 8px 18px;
  color: #515a6e;
  line-height: 22px;
}

.mex-trial-explain .ivu-table .mex-trial-trace-short td {
  background: #ffefe6;
}

.mex-trial-explain .ivu-table .mex-trial-trace-loose td {
  background: #fff9e6;
}

.mex-trial-wrap {
  margin-top: 12px;
}

.mex-trial-nav {
  background: #fff;
  padding: 12px;
  margin-bottom: 10px;
}

.mex-trial-dots {
  margin-top: 8px;
  max-height: 160px;
  overflow: auto;
}

.mex-trial-dot {
  display: inline-block;
  width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  margin: 0 6px 6px 0;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  cursor: pointer;
  background: #fff;
}

.mex-trial-dot.ok {
  background: #19be6b;
  color: #fff;
  border-color: #19be6b;
}

.mex-trial-dot.bad {
  background: #ed4014;
  color: #fff;
  border-color: #ed4014;
}

.mex-trial-dot.warn {
  background: #ff9900;
  color: #fff;
  border-color: #ff9900;
}

.mex-trial-card {
  background: #fff;
  padding: 16px;
}

.mex-trial-meta {
  color: #808695;
}

.mex-trial-stem {
  font-size: 16px;
  line-height: 24px;
  margin: 12px 0;
}

.mex-trial-img {
  max-width: 360px;
  max-height: 220px;
}

.mex-trial-opt-img {
  max-width: 80px;
  max-height: 60px;
  vertical-align: middle;
  margin-left: 8px;
}

.mex-trial-result {
  margin-top: 16px;
  padding: 12px;
  background: #f8f8f9;
  border: 1px solid #e8eaec;
}

.mex-trial-report {
  background: #fff;
  padding: 16px;
  margin-top: 12px;
}

.mex-trial-report h3,
.mex-trial-report h4 {
  margin: 12px 0 8px;
}

.mex-trial-report-hero {
  padding: 12px;
  background: #f8f8f9;
  border: 1px solid #e8eaec;
}

.mex-trial-advice {
  line-height: 24px;
  white-space: pre-wrap;
}

.mex-trial-phone-wrap {
  margin-top: 12px;
}

.mex-trial-phone {
  width: 390px;
  max-width: 100%;
  margin: 0 auto;
  background: #f4efe4;
  border: 8px solid #3d2b1f;
  border-radius: 28px;
  overflow: hidden;
}

.mex-trial-phone-bar {
  background: #2f6b4f;
  color: #fff;
  text-align: center;
  padding: 10px;
  font-size: 13px;
}

.mex-trial-phone-body {
  padding: 16px;
  min-height: 360px;
}

.mex-trial-phone-body h3 {
  margin: 0 0 12px;
  color: #3d2b1f;
}

.mex-trial-phone-body p {
  line-height: 22px;
  margin: 8px 0;
}

.mex-trial-phone-body .ivu-btn {
  margin-top: 12px;
}

.mex-trial-guide {
  margin-top: 8px;
  padding: 10px 12px;
  background: rgba(45, 140, 240, 0.12);
  border-radius: 8px;
  color: #2d8cf0;
  cursor: pointer;
}

.mex-trial-nav {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// MexTrialPaper.vue?2b08e8f3